import React, { useState } from 'react';
import { Gift, Ticket } from 'lucide-react';
import { PageTooltip } from '../components/TooltipSystem';
import { useGiftTarget } from '../components/gift/useGiftTarget';
import { GiftPointsTab } from '../components/gift/GiftPointsTab';
import { GiftCouponTab } from '../components/gift/GiftCouponTab';

export default function AdminGiftPoints() {
  const [tab, setTab] = useState('points'); // "points" | "coupon"
  // Single shared target-selection state — switching tab preserves the
  // chosen segment/customer so the admin doesn't have to redo the picker.
  const ctrl = useGiftTarget();

  return (
    <div className="p-6 md:p-8 lg:p-10 max-w-3xl" data-testid="admin-gift-points-page">
      <PageTooltip page="gift-points" />
      <div className="mb-8">
        <h1 className="text-2xl md:text-3xl tracking-tight font-bold text-[#1A1A1A]">Regala punti e coupon</h1>
        <p className="text-[#64748B] text-sm mt-1">
          Assegna punti bonus o regala un coupon esistente a uno o piu clienti
        </p>
      </div>

      <div className="flex gap-2 mb-6" data-testid="gift-tabs">
        <button onClick={() => setTab('points')} data-testid="tab-points"
          className={`flex-1 h-12 rounded-xl font-semibold text-sm flex items-center justify-center gap-2 border transition-all ${
            tab === 'points' ? 'bg-[#D44E20] text-white border-[#D44E20] shadow-sm' : 'bg-white text-[#64748B] border-slate-200 hover:bg-slate-50'}`}>
          <Gift size={16} /> Regala Punti
        </button>
        <button onClick={() => setTab('coupon')} data-testid="tab-coupon"
          className={`flex-1 h-12 rounded-xl font-semibold text-sm flex items-center justify-center gap-2 border transition-all ${
            tab === 'coupon' ? 'bg-[#D44E20] text-white border-[#D44E20] shadow-sm' : 'bg-white text-[#64748B] border-slate-200 hover:bg-slate-50'}`}>
          <Ticket size={16} /> Regala Coupon
        </button>
      </div>

      {tab === 'points' ? <GiftPointsTab ctrl={ctrl} /> : <GiftCouponTab ctrl={ctrl} />}
    </div>
  );
}
